"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLineItemAllowedToBeCreatedOrEdited = void 0;
const constants_1 = require("./constants");
function isLineItemAllowedToBeCreatedOrEdited(rawDescription) {
    const description = rawDescription.toLowerCase();
    return !constants_1.lineItemDescriptionsForbiddenFromBeingEdited.includes(description);
}
exports.isLineItemAllowedToBeCreatedOrEdited = isLineItemAllowedToBeCreatedOrEdited;
